import React, { FC, useState } from 'react';

import classNames from 'classnames';

import { IconProps } from '../../shared/ui';

// Буквенный знак вместо фирменного логотипа MAX: официального SVG в репозитории нет.
// Заменить на реальный ассет, когда дизайн его отдаст.
export const MaxIcon: FC<IconProps> = ({
  width = 40,
  height = 40,
  fillBg = '#C00000',
  className,
  needHover = true,
}) => {
  const [hover, setHover] = useState(false);

  return (
    <svg
      onMouseMove={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={classNames(className, { 'cursor-pointer': needHover })}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="10" fill={hover && needHover ? '#111026' : fillBg} />
      <text
        x="20"
        y="20"
        textAnchor="middle"
        dominantBaseline="central"
        fill="white"
        fontFamily="Nunito, sans-serif"
        fontSize="12"
        fontWeight="700"
        letterSpacing="0.5"
      >
        MAX
      </text>
    </svg>
  );
};
